<p-blockUI
  [target]="blockTarget"
  [blocked]="isBusy()"
>
  <i class="fa-solid fa-spinner fa-spin text-4xl"></i>
</p-blockUI>
<p-card #blockTarget>
  <form [formGroup]="form" class="formgrid grid">
    <div class="field col-12 lg:col-6">
      <label for="postalCodeInput">PLZ</label>
      <p-dropdown
        id="postalCodeInput"
        [options]="(postalCodeOptions$ | async)!"
        formControlName="postalCode"
        placeholder="PLZ"
        styleClass="w-full"
        [showClear]="true"
        [filter]="true"
      ></p-dropdown>
    </div>
    <div class="field col-12 lg:col-6">
      <label for="cityInput">Ort</label>
      <p-dropdown
        id="cityInput"
        [options]="(cityOptions$ | async)!"
        formControlName="city"
        placeholder="Ort"
        styleClass="w-full"
        [showClear]="true"
        [filter]="true"
      ></p-dropdown>
    </div>
    <div class="field col-12 lg:col-9">
      <label for="streetNameInput">Straße</label>
      <p-dropdown
        id="streetNameInput"
        [options]="(streetNameOptions$ | async)!"
        formControlName="streetName"
        placeholder="Straße"
        styleClass="w-full"
        [showClear]="true"
        [filter]="true"
      ></p-dropdown>
    </div>
    <div class="field col-12 lg:col-3">
      <label for="streetNumberInput">Hausnr</label>
      <p-dropdown
        id="streetNumberInput"
        [options]="(streetNumberOptions$ | async)!"
        formControlName="streetNumber"
        placeholder="Hausnr"
        styleClass="w-full"
        [showClear]="true"
        [filter]="true"
      ></p-dropdown>
    </div>
    <div class="field col-12 mt-4">
      <p-button
        label="Verfügbarkeit prüfen"
        styleClass="w-full"
        (onClick)="checkAvailability()"
        [disabled]="form.invalid || isBusy()"
      ></p-button>
    </div>
  </form>
  <ow-availability-check-result></ow-availability-check-result>
  <ow-base-product
    *ngFor="let product of productsService.availableProducts$ | async"
    [product]="product"
    [variantContractTimeProducts]="productsService.getMatchingVariantContractTimeBaseProducts(product)"
    (choose)="chooseBaseProduct($event)"
  ></ow-base-product>
  <div *ngIf="(productsService.availableProducts$ | async) && (productsService.availableProducts$ | async)!.length > 0" class="text-sm text-gray-500 mt-4">
    <i class="fa-solid fa-asterisk vertical-align-top"></i>
    Alle Preise verstehen sich zuzüglich der gesetzlich gültigen Mehrwertsteuer
  </div>
</p-card>
